import { GlobalStyles } from "library/styled"

/**
 * place all your colors here! the format is:
 * [hex color, optional p3 color]
 *
 * if you provide a p3 color, it will be used where supported
 */
const rawColors = {
	// Blacks and Whites
	black200: ["#081E13"],
	black100: ["#112C2E"],
	offWhite: ["#FBFAF6"],
	white: ["#FFFFFF"],

	// Primary Greens
	green500: ["#153E2A"],
	green400: ["#30715D"],
	green300: ["#6E9E8F"],
	green200: ["#00B684"],
	green100: ["#CCDDC7"],
	greenMain: ["#0E5E49"],

	greenAccent: ["#00DD8C"],

	green100Secondary: ["#0D4D39"],

	purple300: ["#463E88"],
	purple200: ["#ADA2D2"],
	purple100: ["#CDCAD6"],

	// Secondary Blues
	blue500: ["#043C59"],
	blue400: ["#0080AB"],
	blue300: ["#A5DCEE"],
	blue200: ["#ADD2D7"],
	blue100: ["#E8F9FE"],

	// Browns/Tans
	tan300: ["#AC7952"],
	tan200: ["#AE8C66"],
	tan100: ["#CAA88C"],

	// Illustrative Accents on Dark
	orange: ["#D87906"],
	lime: ["#BECC00"],
} as const satisfies Record<string, [string, string] | [string]>

/** widen the type a bit for processing */

const colorEntries: [string, [string, string] | [string]][] =
	Object.entries(rawColors)

/**
 * sets the values of CSS variables globally
 * include this in layout
 */
export const ColorStyle = () => (
	<GlobalStyles>
		{{
			":root": {
				"@supports (not (color: color(display-p3 0 0 0)))": Object.fromEntries(
					colorEntries.map(([key, [hex]]) => {
						return [`--${key.toLowerCase()}`, hex]
					}),
				),
				"@supports (color: color(display-p3 0 0 0))": Object.fromEntries(
					colorEntries.map(([key, [hex, p3]]) => {
						return [`--${key.toLowerCase()}`, p3 ?? hex]
					}),
				),
			},
		}}
	</GlobalStyles>
)

/**
 * convert the raw colors to an object with the correct color for the current browser
 */
const CSSColors = Object.fromEntries(
	colorEntries.map(([key]) => {
		return [key, `var(--${key.toLowerCase()})`]
	}),
) as {
	[key in keyof typeof rawColors]: `var(--${key})`
}

/**
 * gsap can't animate variables, so we need to use the hex always
 */
const jsColors = Object.fromEntries(
	colorEntries.map(([key, [color]]) => {
		return [key, color]
	}),
) as {
	[key in keyof typeof rawColors]: (typeof rawColors)[key][0]
}

export default {
	...CSSColors,
	js: jsColors,
}
